import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 38 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M34.07 1.06a53.25 53.25 0 0 1-30.14 0C2.133.53.323 1.855.323 3.7v18.373c0 1.847 1.757 3.171 3.607 2.64a53.2 53.2 0 0 1 25.987-1.042c.626-1.644.518-1.804 1.598-4.403 1.34 1.403 2.603 3.836 4.13 5.434 1.199-.287 2.033-1.305 2.033-2.675V3.7c0-1.845-1.81-3.17-3.607-2.638M7.795 10.133c-1.033 0-1.868-.821-1.868-1.838s.837-1.838 1.868-1.838 1.868.823 1.868 1.838-.835 1.838-1.868 1.838m20.212 9.454A57 57 0 0 0 19 18.862c-2.944 0-5.877.233-8.772.686-.825.129-1.407-.758-.921-1.427l2.87-3.938a.93.93 0 0 1 .753-.375.94.94 0 0 1 .755.378l1.895 2.556 5.445-7.99a.89.89 0 0 1 .777-.458.94.94 0 0 1 .777.41l6.368 9.482c.448.67-.135 1.526-.94 1.4"
    }, null, -1)
  ]))]))
}
export default { render: render }